import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormBox } from '../forms';

class HomeBox extends PureComponent {
    static propTypes = {
        isActive: PropTypes.bool.isRequired
    };
    render() {
        const { isActive } = this.props;

        return <FormBox isActive={isActive} />;
    }
}

export default HomeBox;



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Home/sections/HomeBox.js